<template>
    <CustomAutocomplete :name="name" :completeFunction="getUsers" :empty-value="emptyValue"
                        v-model="internalValue" item-value="id" :label="label" :required="required"
                        :itemFromQuery="false" :width="width" :customErrorMessage="customErrorMessage"
                        :field="searchParam" :showErrors="showErrors" completeOnFocus
                        :noPlaceholder="noPlaceholder" :dropdown="dropdown"/>
</template>

<script>
    import {getUsers} from "@/swagger/vue-api-client";
    import CustomAutocomplete from "./inner/CustomAutocomplete";

    export default {
        name: "CustomAutocompleteUser",
        props: {
            name: {
                type: String,
            },
            label: {
                type: String,
            },
            emptyValue: {
                type: Boolean,
                default: true,
            },
            required: {
                type: Boolean,
                default: false,
            },
            modelValue: null,
            customErrorMessage: {
                type: String,
                default: "",
            },
            showErrors: {
                type: Boolean,
                default: false,
            },
            dropdown: {
                type: Boolean,
                default: false,
            },
            width: {
                type: String,
                default: null,
            },
            noPlaceholder: {
                type: Boolean,
                default: false,
            },
            searchParam: {
                type: String,
                default: "label",
            },
        },

        emits: ["update:modelValue"],

        computed: {
            internalValue: {
                get() {
                    return this.selectedValue;
                },
                set(value) {
                    this.selectedValue = value;
                    this.$emit("update:modelValue", value.value);
                },
            },
        },

        data() {
            return {
                items: [],
                selectedValue: null,
                getUsers,
            };
        },

        components: {CustomAutocomplete},
    };
</script>

<style scoped>

</style>
